<template>
  <div>
    <BaseCheckbox
      v-if="buttonType === 'checkbox'"
      :id="id"
      :modelValue="renderValue"
      :classState="renderClassState"
      @click="handleModelValueChanged"
    ></BaseCheckbox>
  <!-- 
    <BaseSwitch
      v-else-if="buttonType === 'switch'"
      :id="id"
      :modelValue="renderValue"
      :isDisabled="isDisabled"
      @click="handleModelValueChanged"
    ></BaseSwitch> -->
  
    <BaseButton
      v-if="buttonType === 'button'"
      :id="id"
      :label="label"
      :modelValue="renderValue"
      :classState="renderClassState"
      :circleLight="circleLight"
      @click="handleModelValueChanged"
    ></BaseButton>
  
    <BaseButtonIcon
      v-else-if="buttonType === 'buttonIcon'"
      :id="id"
      :svgPath="svgPath"
      :classState="renderClassState"
      @click="handleModelValueChanged"
    ></BaseButtonIcon>
  
    <BaseButtonIconText
      v-else-if="buttonType === 'buttonIconText'"
      :id="id"
      :svgPath="svgPath"
      :label="label"
      :iconBeforeLabel="iconBeforeLabel"
      :classState="renderClassState"
      @click="handleModelValueChanged"
    ></BaseButtonIconText>
  
    <BaseSelect
      v-else-if="buttonType === 'select'"
      :id="id"
      :modelValue="renderValue"
      :classState="renderClassState"
      :options="selectOptions"
      :optionDefault="selectOptionDefault"
      :target="selectTarget"
      @SelectClicked="handleModelValueChanged"
    ></BaseSelect>
 
    <BaseInputText
      v-else-if="buttonType === 'input'"
      :id="id"
      :modelValue="renderValue"
      :classState="renderClassState"
      @InputChanged="handleModelValueChanged"
    ></BaseInputText>

    <BaseNumberIncrement
      v-else-if="buttonType === 'numberIncrement' &&  (renderValue || renderValue === 0)"
      :id="id"
      :modelValue="renderValue"
      :classState="renderClassState"
      :longpress="longPress"
      :min="min"
      :max="max"
      :suffix="suffixName"
      :incrementValue="incrementValue"
      @IncrementChanged="handleModelValueChanged"
    ></BaseNumberIncrement>
  <!--
    <BaseSelectIncrement
      v-else-if="buttonType === 'selectIncrement'"
      :id="id"
      :modelValue="renderValue"
      :classState="renderClassState"
      :longpress="longPress"
      :selectOptions="selectOptions"
      :min="min"
      :max="max"
      :isCyclic="true"
      @IncrementChanged="handleModelValueChanged"
    ></BaseSelectIncrement>
  
    <BaseSlider
      v-else-if="buttonType === 'slider'"
      :id="id"
      :modelValue="renderValue"
      :min="min"
      :max="max"
      :suffix="suffixName"
      :complex="withComplexSlider"
      :classState="renderClassState"
      @SliderChanged="handleModelValueChanged"
    ></BaseSlider> -->

    <BaseTextArea
      v-else-if="buttonType === 'textArea'"
      :id="id"
      :modelValue="renderValue"
      :classState="renderClassState"
      @InputChanged="handleModelValueChanged"
    ></BaseTextArea>

  </div>

</template>

<script>
import { debounce } from 'lodash';

import { t_subscribe } from "@/lib/tui/compositions/persistance.js";
import BaseCheckbox from "@/lib/tui/components/buttons/Refacto/BaseCheckbox.vue";
// import BaseSwitch from "@/lib/tui/components/buttons/Refacto/BaseSwitch.vue";
import BaseButton from "@/lib/tui/components/buttons/Refacto/BaseButton.vue";
import BaseButtonIcon from "@/lib/tui/components/buttons/Refacto/BaseButtonIcon.vue";
import BaseSelect from "@/lib/tui/components/buttons/Refacto/BaseSelect.vue";
import BaseInputText from "@/lib/tui/components/buttons/Refacto/BaseInputText.vue";
import BaseNumberIncrement from "@/lib/tui/components/buttons/Refacto/BaseNumberIncrement.vue";
// import BaseSelectIncrement from "@/lib/tui/components/buttons/Refacto/BaseSelectIncrement.vue";
// import BaseSlider from "@/lib/tui/components/buttons/Refacto/BaseSlider.vue";
import BaseButtonIconText from "@/lib/tui/components/buttons/Refacto/BaseButtonIconText.vue";
import BaseTextArea from "@/lib/tui/components/buttons/Refacto/BaseTextArea.vue";

export default {
  name: "TrinnovInput",
  ////////////////////////////////////////////////////////////////////////
  ////////////////////////////////////////////////////////////////////////
  components: {
    BaseCheckbox,
    // BaseSwitch,
    BaseButton,
    BaseButtonIcon,
    BaseSelect,
    BaseInputText,
    BaseNumberIncrement,
    // BaseSelectIncrement,
    // BaseSlider,
    BaseButtonIconText,
    BaseTextArea
  },
  ////////////////////////////////////////////////////////////////////////
  ////////////////////////////////////////////////////////////////////////
  props: {
    id: [Number, String],
    target: String,
    buttonType: {
      type: String,
      default: "input" // input => inputText
    },
    modelValue: {
      type: [Number, String, Boolean],
      default: false
    },
    onValidation: Function,
    event: {
      type: Boolean,
      default: false
    },
    dataType: {
      type: String,
      default: "toggle"
    },
    incrementStep: {
      type: Number,
      default: 1
    },
    subscribe: {
      type: String
    },
    autoPubreq: {
      type: Boolean,
      default: false
    },
    pubreq: Array,
    label: String,
    size: {
      type: String,
      default: "medium"
    },
    svgPath: String,
    isActivable: {
      type: Boolean,
      default: true
    },
    isDisabled: {
      type: Boolean,
      default: false
    },
    isWarning: {
      type: Boolean,
      default: false
    },
    isError: {
      type: Boolean,
      default: false
    },
    // Params liés aux bouttons
    buttonClass: String,
    circleLight: {
      type: Boolean,
      default: false
    },
    // Params liés aux icons
    withBackground: {
      type: Boolean,
      default: true
    },
    withSquare: {
      type: Boolean,
      default: false
    },
    iconBeforeLabel: {
      type: Boolean,
      default: false
    },
    iconReverted: {
      type: Boolean,
      default: false
    },
    // Param lié au select
    selectOptions: Array,
    selectOptionDefault: [String, Boolean],
    selectTarget: String,
    // Params liés au increment
    min: {
      type: Number,
      default: 0
    },
    max: {
      type: Number,
      default: 10
    },
    longPress: {
      type: Boolean,
      default: false
    },
    isCyclic: {
      type: Boolean,
      default: false
    },
    incrementValue: {
      type: Number,
      default: 1
    },
    // Param lié au slider
    withComplexSlider: {
      type: Boolean,
      default: false
    },
    suffixName: {
      type: String,
      default: ""
    }
  },
  ///////////////////////////////////////////////////////////////////////////
  ///////////////////////////////////////////////////////////////////////////
  setup(props) {

    if (!props.subscribe) return;

    let subscribe_options = [
      {
        property: "valueSubscribed",
        path: props.subscribe,
        autoPubreq: props.autoPubreq
      }
    ];

    t_subscribe(subscribe_options);
  },
  ///////////////////////////////////////////////////////////////////////////
  ///////////////////////////////////////////////////////////////////////////
  data () {
    return {
      valueSubscribed: null
    }
  },
  ////////////////////////////////////////////////////////////////////////
  ////////////////////////////////////////////////////////////////////////
  methods: {
    handleModelValueChanged: debounce(function(event) {
      if (this.isDisabled) return;
      let newValue = this.renderValue;

      if (this.onValidation && typeof(this.onValidation) == "function") {
        console.log("on s'occupe de la validation");
      }

      if (this.buttonType === "select" || this.buttonType === "input" || this.buttonType === "numberIncrement" 
      || this.buttonType === "selectIncrement" || this.buttonType === "slider" || this.buttonType === "textArea") {
        newValue = event.value;
      }
      else if (this.dataType === "toggle"  || this.dataType === "toggleInverted") {
        if (typeof this.renderValue === "boolean") 
          newValue = !this.renderValue;
        else if (typeof this.renderValue === "number") {
          newValue = this.renderValue == 0 ? 1 : 0;
          console.warn("Persistance must use Boolean for toggle function");
        }
      }
      else if (this.dataType === "increment" || this.dataType === "decrement") {
        if (typeof (this.renderValue) === "number") {
          newValue = this.dataType === "increment" ? this.renderValue + this.incrementStep : this.renderValue - this.incrementStep;
        }
        else
          console.warn("dataType is increment/decrement but value is not a number");
      }
      else {
        console.warn("Case not handled");
      }

      if (this.subscribe && this.autoPubreq) {
        this.valueSubscribed = newValue;
        return;
      }

      if (this.pubreq) {
        // Pubreq sur un chemin persistance avec une valeur fixe
        if (
          Array.isArray(this.pubreq) &&
          this.pubreq.length === 2 &&
          typeof this.pubreq[0] === "string" &&
          typeof this.pubreq[1] === "object"
        )
        console.log("on fait un pubreq")
          //window.t.pubreq(this.pubreq[0], this.pubreq[1]);
        // Pubreq sur un chemin persistance avec modification de la valeur (toggle par défaut)
        else if (
          Array.isArray(this.pubreq) &&
          this.pubreq.length === 2 &&
          typeof this.pubreq[0] === "string" &&
          typeof this.pubreq[1] === "string"
        ) 
        console.log("on fait un pubreq")
          //window.t.pubreq(this.pubreq[0], { [this.pubreq[1]] : newValue });
        else
          console.warn(
            "id: " + this.id + " pubreq: " + this.pubreq + " has no persistance data"
          );
        return;
      } 

      if (this.event) {
        this.$emit("TrinnovInputChanged", { id: this.id, value: newValue, target: this.target });
        return;
      }

      this.$emit('update:modelValue', newValue);
    }, 5),
  },
  ////////////////////////////////////////////////////////////////////////
  ////////////////////////////////////////////////////////////////////////
  computed: {
    renderValue: function() {
      if (this.subscribe)
        return this.valueSubscribed;

      if (this.buttonType === "input" && (this.modelValue === true || !this.modelValue)) return "";
      return this.modelValue;
    }, 
    ////////////////////////////////////////////////////////////////////////
    renderClassState: function() {
      if ((!this.modelValue && this.modelValue !== false && this.modelValue !== 0 && this.modelValue !== "") 
      && (!this.valueSubscribed && this.valueSubscribed !== false && this.valueSubscribed !== 0 && this.valueSubscribed !== "")) return;

      let output = this.buttonType + "-trinnov";

      if (this.buttonType === "buttonIcon" || this.buttonType === "buttonIconText") {
        output += !this.withBackground ? ' no-background' : '';
        output += this.withSquare ? ' square-background' : '';

        if (this.isActivable) {
          output += " hover-active";
        }

        if (this.iconReverted) {
          output += " reverted"
        }
      }
      else if (this.buttonType === "button")
        output += this.buttonClass ? ' ' + this.buttonClass : '';

      if (this.isActivable) {
        if (this.buttonType !== "select" && this.buttonType !== "input" && this.buttonType != "numberIncrement") {
          if (typeof(this.modelValue) == "boolean")
            output += this.modelValue ? ' active' : '';
          else if (typeof(this.modelValue) == "number")
            output += this.modelValue === 1 ? ' active' : '';
          
          if (typeof(this.valueSubscribed) == "boolean")
            output += this.valueSubscribed ? ' active' : '';
          else if (typeof(this.valueSubscribed) == "number")
            output += this.valueSubscribed === 1 ? ' active' : '';
        }
      }

      output += " " + this.size;

      if (this.isDisabled)
        output += " disabled";
      if (this.isWarning)
        output += " warning";
      if (this.isError)
        output += " error";

      return output;
    }
  }
}
</script>

<style lang="scss" scoped>
@import "@/lib/tui/scss/module/trinnovButton.scss";
</style>